// extracted by mini-css-extract-plugin
export var card = "_lj-5";
export var cardSelected = "_lj-4";
export var image = "_lj-3";
export var modal = "_lj-0";
export var modalContent = "_lj-1";
export var table = "_lj-2";